import React, { FC, useMemo, useRef } from 'react';

import { Button, Center, Flex, Heading, Text } from '@chakra-ui/react';

import { MdAddLocationAlt } from 'react-icons/md';

import {
  AddCollectionPointModal,
  AddCollectionPointModalRef,
} from 'components/modules/AddCollectionPoint';
import {
  EditCollectionPointModal,
  EditCollectionPointModalRef,
} from 'components/modules/EditCollectionPoint';
import { UserPill } from 'components/core/UserPill';
import { DataTable } from 'components/modules/DataTable';
import { washHub } from 'store';
import { CollectionPoint } from 'types/location';
import { CollectionPointsViewProps } from './CollectionPoints.props';
import { useSites } from 'hooks/sites/useSites';

import { buildCollectionPointColumns } from './collectionPointsColumns';

const CollectionPointsView: FC<CollectionPointsViewProps> = (props) => {
  const { points, isLoading, pagination } = props;
  const selectedWashHub = washHub.selectors.useSelectedWashHub();
  const washHubId = selectedWashHub?._id || '';
  const addCollectionPointRef = useRef<AddCollectionPointModalRef>(null);
  const editCollectionPointRef = useRef<EditCollectionPointModalRef>(null);
  const sites = useSites();
  const allSites = sites.data || [];

  const columns = useMemo(() => buildCollectionPointColumns(allSites), [
    allSites,
  ]);

  return (
    <Flex direction="column" flex={1} color="support.500" overflow="auto">
      <Flex alignItems="baseline" justify="space-between">
        <Heading fontSize="24px">Collection Point</Heading>
        <Flex align="flex-end">
          <Button
            isDisabled={washHubId === ''}
            mr={2}
            minW="200px"
            leftIcon={<MdAddLocationAlt size="20px" />}
            onClick={() => {
              addCollectionPointRef?.current?.onOpen?.();
            }}>
            Create Point
          </Button>
          <UserPill />
        </Flex>
      </Flex>
      <Flex h="50px" />
      <DataTable<CollectionPoint>
        minW="980px"
        data={points}
        columns={columns}
        isLoading={isLoading}
        pagination={pagination}
        onRowClick={(point) => {
          editCollectionPointRef?.current?.onOpen?.(point);
        }}
        renderEmpty={() => (
          <Center p={8}>
            <Text fontSize="20px">No Collection Points available</Text>
          </Center>
        )}
      />
      <AddCollectionPointModal ref={addCollectionPointRef} />
      <EditCollectionPointModal ref={editCollectionPointRef} />
    </Flex>
  );
};

export default CollectionPointsView;
